import React from "react";
import { Plus } from "lucide-react";
import { TYPES, iso, addDays, rangeFor } from "./calUtils";
import { EventChip } from "./EventChip";

const MAX = 3;

export function MonthView({ cursor, byDate, closures, onOpen, onDay, onAdd }) {
  const [start] = rangeFor("month", cursor);
  const today = iso(new Date());
  const days = Array.from({ length: 42 }, (_, i) => addDays(start, i));
  return (
    <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden" data-testid="cal-month-view">
      <div className="grid grid-cols-7 border-b border-gray-100 bg-background">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => <div key={d} className="text-center text-[11px] font-bold uppercase tracking-wide text-muted-foreground py-2">{d}</div>)}
      </div>
      <div className="grid grid-cols-7">
        {days.map((d) => {
          const ds = iso(d);
          const list = byDate[ds] || [];
          const inMonth = d.getMonth() === cursor.getMonth();
          return (
            <div key={ds} role="button" tabIndex={0} data-testid={`cal-day-${ds}`} onClick={() => onDay(d)} onKeyDown={(e) => e.key === "Enter" && onDay(d)}
              className={`group min-h-[76px] sm:min-h-[112px] border-b border-r border-gray-100 p-1 cursor-pointer hover:bg-teal-light/30 transition-colors ${inMonth ? "" : "bg-background/60"} ${closures.has(ds) ? "bg-orange-50/60" : ""}`}>
              <div className="flex items-center justify-between mb-0.5">
                <span className={`text-xs font-semibold flex items-center justify-center w-6 h-6 rounded-full ${ds === today ? "bg-teal text-white" : inMonth ? "text-gray-700" : "text-gray-300"}`}>{d.getDate()}</span>
                {onAdd && <button type="button" aria-label="Add event" data-testid={`cal-add-${ds}`} onClick={(e) => { e.stopPropagation(); onAdd(ds); }}
                  className="opacity-0 group-hover:opacity-100 text-teal hover:bg-teal-light rounded-full w-5 h-5 hidden sm:flex items-center justify-center transition-opacity"><Plus className="w-3.5 h-3.5" /></button>}
              </div>
              <div className="hidden sm:block space-y-0.5">
                {list.slice(0, MAX).map((it) => <EventChip key={it.uid} it={it} onOpen={onOpen} />)}
                {list.length > MAX && <button type="button" data-testid={`cal-more-${ds}`} onClick={(e) => { e.stopPropagation(); onDay(d); }}
                  className="text-[11px] font-semibold text-teal-dark hover:underline px-1.5">+{list.length - MAX} more</button>}
              </div>
              <div className="sm:hidden flex flex-wrap gap-0.5 px-0.5" data-testid={`cal-dots-${ds}`}>
                {list.slice(0, 4).map((it) => <span key={it.uid} className="w-1.5 h-1.5 rounded-full" style={{ background: (TYPES[it.type] || TYPES.event).bg }} />)}
                {list.length > 4 && <span className="text-[9px] text-muted-foreground leading-none">+{list.length - 4}</span>}
              </div>
            </div>);
        })}
      </div>
    </div>);
}
